/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Whether an entitlement currently grants access, and if not, why. Derived, never stored.
 */
export type EntitlementStatus =
  (typeof EntitlementStatus)[keyof typeof EntitlementStatus];

export const EntitlementStatus = {
  ACTIVE: "ACTIVE",
  PENDING: "PENDING",
  EXPIRED: "EXPIRED",
  EXHAUSTED: "EXHAUSTED",
  REVOKED: "REVOKED",
} as const;
